import styled, { css } from "styled-components";

export const Tabs = styled.div`
	display: flex;
`;
export const TabItem = styled.div`
	font-size: var(--general-tab-font-size);
	font-weight: var(--general-tab-font-weight);
  text-align: center;
  width: ${(props) => (props.width ? props.width : "9rem")};
  font-size: var(--general-tab-font-size);
  cursor: pointer;
  margin: 0;
	color: ${(props) => (props.selected ? "#2555ef" : "rgb(123, 123, 139)")};
	${(props) =>
		props.selected &&
		css`
			&:after {
				content: "";
				display: block;
				margin: 0 auto;
				margin-top: 5px;
				width: 100%;
				border-bottom: 4px solid #2555ef;
				border-radius: 6px;
			}
		`}
`;
